import { requst } from '../config'

// 字典数据树
export const getMagnetismDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}